'use client';

import { useDealershipId } from '~/context/dealership/StaticContext';
import useIsInServiceLandingExperiment from '~/hooks/dealership/useIsInServiceLandingExperiment';
import ServiceLandingPage from './ServiceLandingPage';
import TekionIframe from './TekionIframe';

type OwnProps = {
  tekionIframeSrc: string;
  dealershipName: string;
};

export default function ServiceExperimentGate({
  tekionIframeSrc,
  dealershipName
}: OwnProps) {
  const dealershipId = useDealershipId();
  const isInTreatment = useIsInServiceLandingExperiment();
  const isParkCities = dealershipId === 'dal-cdjr-new';

  if (isParkCities && isInTreatment) {
    return <ServiceLandingPage />;
  }

  return <TekionIframe src={tekionIframeSrc} title={dealershipName} />;
}
